import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

const ChangeAccessModal = ({ open, handleClose, roles, selectedRole, handleRoleSelectChange, handleChangeAccess }) => {
    return (
        <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
            <DialogTitle>Change Access</DialogTitle>
            <DialogContent>
                <FormControl fullWidth>
                    <InputLabel id="role-select-label">Role</InputLabel>
                    <Select
                        value={selectedRole}
                        label="Role"
                        onChange={handleRoleSelectChange}
                    >
                        {roles.map((role) => (
                            <MenuItem key={role.role_id} value={role.role_name.toUpperCase()}>
                                {role.role_name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    <span className='text-trans-none'>Cancel</span>
                </Button>
                <Button
                    onClick={handleChangeAccess}
                    color="primary">
                    <span className='text-trans-none'>Change Access</span>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangeAccessModal;
